export const m = {
  header: {
    navbar: {
      HELLO: "こんにちは",
      LOGOUT: "ログアウト",
      TITLE: "Japan Nightへようこそ",
      new: {
        NEW: "新規",
        PROJECT: "プロジェクト",
        TASK: "タスク",
        USER: "ユーザー",
        EMAIL: "メール"
      },
      NOTIFICATIONS: "お知らせ",
      APP_TITLE: "Japan Night"
    }
  },
  aside: {
    APPNAME: "Japan Night",
    nav: {
      INDEX: "ホーム",
      SHOPS: "店舗管理",
      SHOP: "店舗",
      ROOM: 'VIP RESERVATION管理',
      TIME: '時間管理',
      ACTIVITYS_TUBE: "イベント管理",
      ACTIVITYS: "イベント",
      ACTIVITY_CATEGORY: "イベント分類",
      ACTIVITYS_SAT: "イベント集計",
      LIVES: "中継管理",
      LIVE: "中継設定",
      ORDER_TUBE: "注文管理",
      ORDER: "イベント注文",
      ORDER_SAT: "注文集計",
      USERGOODS_MANAGEMENT: 'ユーザー商品管理',
      MEMBERS: "会員管理",
      MEMBER: "会員",
      MEMBEROFFCIAL: "カスタマーサービス設定",
      MEMBERS_BANNED: "メンバーブラックリスト記録",
      MEMBER_RECHARGE_MANAGE: "ゴールドメンバー管理",
      MEMBER_RECHARGE: "ゴールドメンバー",
      COUPON: "クーポン券",
      COUPON_MANAGE: "クーポンリスト",
      COUPON_TABLE: "クーポン配るリスト",
      COUPON_REGISTER: "招待用クーポン設定",
      COUPON_USEAGE_RECORD: 'クーポン利用履歴',
      ARTICLES: "テキスト管理",
      ARTICLE: "テキスト",
      COMMENDS: "コメント管理",
      COMMEN: "コメント",
      RECHARGES: "資金管理",
      RECHARG: "チャージ履歴",
      GAME: "ゲームの設定",
      PRIZE_SET: "当たり設定设置",
      PRIZE_DETAILS: "ゲームの消費明细",
      BACKSTAGE: "管理ページ",
      ROLE: "役割管理",
      SHOPROLE: "店舗管理者設定",
      ACCOUNT: "JP管理者設定",
      SYSLOGS: "操作ログ",
      LANGUAGES: "多言語設定",
      MUSICS: "音楽ジャンル",
      REGIONS: "エリア設定",
      RECEPTION: "フロントの機能",
      BANNER: "広告管理",
      SPLASHE: "スプラッシュ管理",
      VERSIONS: " バージョン管理",
      PUSHES: "プッシュ通知管理",
      CONFIG: "設定",
      CONFIG_FEATURE: "汎用機能管理",
      CONFIG_APP: "業務系機能設定",
      INVITATE_CODES: "招待コード管理",
      INVITATE_CODE: "招待コード",
      DIALOG_MANAGEMENT: "ポップアップ管理",
      POPUP: "ポップアップ",
      THEMES: "テーマ管理",
      THEME: "テーマ",
      MENBER_CHARGE: "会員チャージ",
      CHARGE_OFF: "販売権限",
      USER_MANAGE: "ユーザー管理",
      CARD_GROUP_STYLE: "カードセットの仕様管理",
      CARD_GROUP: "カードグループ管理",
      CARD: "カード管理",
      PREMISSION_MANAGE: "権限管理",
      MODEL: "テンプレート管理",
      PAGE: "ページ管理",
      CONFIG_MANAGE: "配置管理",
      LABEL: "タグ管理",
      LOTTERY: "抽選権",
      TICKET: "チケット管理",
      USERGOODS_MANAGEMENT: 'ユーザー商品管理',
      GIFT: "ギフト管理",
      FULL_AMOUN_COUPON: "全額クーポン券管理",
      COIN_MANAGE: "チャージ管理",
      COIN_RECHARGE: "コインのチャージ管理",
      COIN_RECHARGE_RECORDE: "コインチャージの履歴",
      GIFT_REWARD: "投げ銭集計",
      GIFT_CATEGORY: "ギフトカテゴリ",
      LIVE_CATEGORY: "配信チャンネル",
      SHOP_CATEGORY: "店舗カテゴリ",
      SHOP_APPLY: "お店の掲載申請",
      RETURN_POINT: "ポイント還元記録",
      PRESENT_SET: "景品設定",
      RECHANGE_PRESENT: "景品交換履歴",
      RECHANGE_MANAGEMENT: "景品管理",
      POINTS: "ポイント管理"
    }
  },
  content: {
    common: {
      ACTION: "操作",
      EDIT: "編集",
      SAVE: "保存",
      COPY: "コピー",
      DELETE: "削除",
      IS_DELETE: "削除しますか?",
      CREATE: "新規",
      NUMBER: "番号",
      STATUS: "ステータス",
      SORT: "並び替え",
      SEARCH: "検索",
      RESET: "リセット",
      ACTION_ALL: '一括設定',
      DELETE_ALL: "一括削除",
      APPLY: "適用",
      DETAIL: "詳細",
      CLOSE: "閉じる",
      OPEN: "開く",
      LINK: "リンク",
      SURE: "確認",
      CANCEL: "キャンセル",
      REFUSE: "拒否",
      ADOPT: "通過する",
      TEL: "電話",
      PLEASE_INPUT: '入力してください',
      LINK_ZDY: "カスタマイズ",
      LINK_REMINDER: "リンクのタイプ",
      LINK_REMINDER_UP: "リンクの入力",
      SELECTPICTURE: "画像を選択",
      PLEASE_SELECTPICTURE: "画像を選択してください",
      RIGHT_SELECTPICTURE: "右側のボタンをクリックして画像をアップロード",
      PLATFORM: "プラットフォーム",
      SELECT: "選択してください",
      WRITE: "入力してください",
      PHOTO: "画像",
      PLEASE_AREA_CODE: "国・地域番号を選択してください",
      PLEASE_WRITE_TEL: "電話番号を入力してください",
      PHOTO_RESTRICT: "画像制限",
      PHOTO_UPLOADING: "画像をアップロード",
      VIDEO_UPLOADING: "動画をアップロード",
      CLICK_UPLOADING: "クリックしてアップロード",
      ZIP_UPLOADING: "zipのみアップロード可能",
      OPEN_TIME: "開始時間",
      OFF_TIME: "終了時間",
      OPEN_OFF_TIME: '開始&終了時間',
      PLEASE_SORT: "表示順を入力してください",
      SORT_INT: "整数を入力してください",
      USER_NAME: "ユーザー名",
      USER_TEL: "ユーザー電話番号",
      EGION_ALL: "すべてのエリア",
      PASSWORD: "パスワード",
      PASSWORD_AT: "新しいパスワード",
      TIPS_PASSWOR: "変更しない場合は入力不要",
      VERIFY_PASSWORD: "パスワードを確認してください",
      PLEASE_PASSWORD: "正しいパスワードを入力してください",
      PLEASE_VERIFY_PASSWORD: "もう一度パスワードを入力してください",
      NOT_VERIFY_PASSWORD: "入力したパスワードは不一致です",
      PHOTO_REQIREMENT: "アップした画像が正しくありません",
      CONFIG_DELERTE: "削除しますか？",
      SUCCESSFUL_OPERASTION: "更新されました",
      SUCCESSFUL_FAILED: "更新失敗です",
      PLEASE_OPEN_TIME: "開始時間を選択",
      PLEASE_OFF_TIME: "終了時間を選択",
      STARTTIME_LESS_ENDTIEM: "開始時間は終了時間より前です",
      LATITUDE_AND_LONGITUDE: "経緯度は取得できません",
      EDITORS: "編集中",
      CREATION: "新規作成中",
      PRICE_SEVEN: "価格は７桁を超えてはいけません",
      PRICE_INTEGER: "価格は0以上の整数しか入力できません",
      PRICE_CONFIG_DELERTE: "削除項目を選択してください",
      REMINDER: "ヒント",
      TOTAL_PAGE: "合計",
      JUMP_TOTAL: "ページ",
      JUMP_PAGE: "移動先",
      YES: "はい",
      NO: "いいえ",
      SIZE: "サイズ",
      addimage: "画像を追加する",
      NODATA: "データなし",
      LOADING: "ローディング····",
      LIST_NULL: "データがありません",
      ADD: "追加する",
      IMAGE_NLL: "画像をアップロードしてください",
      PASSWORD_LESS: "パスワードが6文字以上となります",
      READ: "ビュー",
      PREMISSION: "権限",
      COUNT: "数量",
      IP: "IPアドレス",
      NULL: "なし",
      IOS: "iOS",
      ANDROID: "Android",
      ALL_PLATEFORM: "全てプラットフォーム",
      UPLOAD_IMAGE_NULL: "画像のサイズが要件に満たしていません",
      UPLOAD_IMAGE_SUPPORT: "画像の種類がサポートされません",
      UPLOAD_IMAGE_NOT: "画像サイズを2MB以内にしてください",
      SEND_SUCCESS: "送信成功",
      LINK_UPLOAD: "アップロードする画像のリンク先を入力してください",
      DELETE_SUCCESS: "削除成功",
      DELETE_FAIL: "削除失敗",
      ADMIN: "管理コンソール",
      CHECK: "販売者アプリ",
      H5: "ウェブページ",
      REGION_VALID: "店舗エリアは都市レベルで詳細にする必要があります",
      CREATE_SUB_CATEGORY: "サブカテゴリを作成する",
      SUB_NUM: "サブカテゴリの数",
      CREATE_SUCCESS: "正常に作成されました",
      CREATE_FAILD: "作成に失敗しました",
      JAPAN_LANGUAGE: "日本語",
      CHINESE_LANGUAGE: "简体中文",
      SURE_PHYSICAL:
        "ファイルを物理的に削除します（ファイルを削除すると、参照されている画像が無効になります。慎重に決定してください）",
      UPLOAD_ORIGIN: "写真をアップロードする",
      URL_UOPLOAD: "URLを追加",
      PICLIST: "ギャラリーセレクション",
      ZHI: "から",
      PLEASE_CATEGORY: "カテゴリを選択しください",
      APPLY_SUCCESS: "審査通過",
      APPLY_FALIED: "審査却下",
      IS_APPLY_SUCCESS: "申請を許可しますか？",
      IS_APPLY_REFUSED: "申請を却下しますか？",
      PLEASE_EMAIL: "正しいメール形式を入力しください",
      TIWCE_PASSWORD: "パスワードは不一致です",
      STOCK_INT: "在庫数は整数を入力",
      EXPORT_PRESENT_RETURN: "景品交換履歴をダウンロード",
      PRESENT_RETURN_MANY: "一万件以上の記録は吐き出すこと出来ません",
      CHANGE_SHOP: "店舗を変えますか？",
      TIP: "ヒント",
      MAPS: '地図',
      CANCEL_CHANGE: "キャンセル",
      MAPS_LOADING: "マップの読み込み",
      MAPS_FAIL: "マップを読み込めませんでした",
      NET_ERR: "ネットワークエラー",
      UPLOAD_SUCCESS: "アップロードされた",
      CLICK_FOR_DETAIL: '詳細はこちら',
      RECORD: "記録数",
      QUICK_TRANSLATION: '翻訳を見る',
      EXPORT_LOADING: 'データー吐き出し中、ダウンロードリストよりご確認ください',
      DOWN_LOAD: 'ダウンロード',
      INPUT_INT:'整数を入力してください',
      INPUT_NO_MINUS:'0以上の整数を入力してください',
      INPUT_INCOMPLETE: '完全に記入されていません',
    },
    index: {
      ALLUSER: "総ユーザ数",
      ACTIVITYUSERS: "アクティブユーザ",
      NEWUSERS: "新規登録ユーザ",
      LAUNCHES: "起動回数",
      USER_ONLINE: "視聴人数",
      TODAY: "本日",
      YESTERDAY: "昨日",
      TIME_FRAME: '時間',
      EXPORT: 'データ抽出',
      DASHBOARD_EXPORT: 'データ抽出',
    },
    shop: {
      SHOPLIST: "店舗一覧",
      SHOP_CREATE: "新規店舗",
      SHOP_MODIFY: "店铺を修正",
      SHOPLOGO: "店舗ロゴ",
      TITCKELOGO: "チケット用ロゴ",
      SHOPNAME: "店舗名",
      SHOP_REGIONS: "店舗エリア",
      SHOP_SITE: "店舗住所",
      SHOP_TEL: "店舗電話番号",
      SHOP_ACTIVITY_COUNtT: "イベント数",
      SHOP_LIKE_COUNtT: "いいね数",
      RECOMMEND: "おすすめ",
      SHOP_DETAIL: "店舗情報",
      PLEASE_ENTER_SHOPNAME: "店舗名を入力してください",
      SHOP_KEYWORD: "店舗検索キーワード",
      PLEASE_SHOP_KEYWORD: "検索キーワードを入力してください",
      SHOP_ADMIN: "店舗オーナー",
      PLEASE_SHOP_ADMIN: "店舗オーナーを選びください",
      PLEASE_SHOP_ADMINISTRATORDS: "店舗管理者を選択してください",
      SHOP_TIME: "営業時間",
      STATISTICS_TIME: "集計時間",
      SHOP_DESC: "店舗紹介",
      SHOP_OPEN: "営業中",
      SHOP_OFF: "休業",
      PLEASE_SHOP_DESC: "店舗紹介文を入力してください",
      PLEASE_SHOP_SITE: "住所を入力してください",
      SHOP_URL: "店铺URL",
      PLEASE_SHOP_REGIONS: "地域を選択してください",
      PLEASE_SHOP_OPEN_TIME: "開始時間を選択してください",
      PLEASE_SHOP_OFF_TIME: "終了時間を選択してください",
      PLEASE_TATOL_OPEN_TIME: "集計開始時間を選択してください",
      PLEASE_TATOL_OFF_TIME: "集計終了時間を選択してください",
      PLEASE_WRITE_LINK: "正しいサイトを入力してください",
      PLEASE_SHOP_STATUS: "ステータスを選択してください",
      PLEASE_SHOP_TEL: "管理者の電話番号を入力してください",
      SHOP_TEL_NUMbER: "電話番号は数字のみです",
      SHOP_LIKE_COUNtT_NUMBER: "仮いいね数は数字のみです",
      PLEASE_SHOP_DESC_LENGTH: "店舗住所が最大文字数を超えました",
      SHOP_ACTIVITY: "店舗所有イベント",
      PLEASE_SHOP: "店舗を選択してください",
      PHOTO_PESOLVING: "解像度は320*320以上にしてください",
      ACTIVITYS_CAN: "購入制限有効",
      PRODUCT_CAN: "商品のオンライン購入を許可しますか",
      BADGE_CAN: "バッジを有効にしますか",
      SHOP_IS_DISPLAY: "店舗展示を有効にしますか",
      BADGE_NAME: "バッジ名",
      BADGE_LOGO: "バッジ用ロゴ",
      SHOPS_PESOLVING: "解像度は200*100以下にしてください",
      SHOP_CODE: "店舗QRコード",
      DOWNLOAD_CODE: "QRコードダウンロード",
      ALL_SHOPS_APPLY: "全店舗利用可能",
      SHOP_PICTURES: "店舗画像",
      SHOP_BASIC_DETAIL: "店舗基本情報",
      SHOP_TYPE: "店舗タイプ",
      SHOP_STATUS_SET: "店舗状態設定",
      SHOP_THREE: "第三者店舗",
      BADGE_DESC: "バッジ特典説明",
      PLEASE_BADGE_DEAC: "バッジの説明を入力してください",
      LINK_ADD_IMAGE: "リンクから画像を追加する",
      ADVISE_SIZE_IS: "推奨サイズは",
      SIZE_NOT: "大きさは2MBまで",
      MORE_THAN: "最大アップロード数",
      CHANGE_PICTURE_ORDER: "ドラッグして画像の順番が変更可能",
      ADD_COUPON: "クーポンを追加する",
      NO_INFER: "以降の住所を入力してください",
      IS_RECOMMEND: "おすすめしますか？",
      PLEASE_BADGE_NAME: "バッジ名を入力してください",
      IS_OPEN_WOMANMENBER: "ビューティー会員を有効にしますか",
      WOMANMENBER_DESC: "ビューティー会員説明",
      WOMANMENBER_LOGO: "ビューティー会員用ロゴ",
      PLEASE_UPLOAD_LOGO: "店舗ゴロをアップロードしてください",
      AA_SHOP_CATEGORY: "店舗種類を作成",
      PLEASE_SHOP_CLASS: "店舗種類を選択してくだい",
      SHOP_MANAGEMENT_SET: "店舗運営設定",
      PLATE_MYSELEF: "JP運営",
      OTHER_MANAGE: "第三者運営",
      REVIEWS: "レビュー数",
      NIGHT_CLUB: "ナイトクラブ",
      BAR: "バー",
      CLUB: 'キャブクラ＆ホスト',
      WAITER: 'キャスター',
      WAITER_CREATE: 'キャスター作成',
      WAITER_DETAIL_BASIC: '基本情報',
      WAITER_DETAIL_RESUME: 'キャスター用Q&A',
      WAITER_DETAIL_SCHEDULE: '出勤表',
      WAITER_AVATAR: 'アバター',
      WAITER_BODY_DATA: '体型データ',
      WAITER_BODY_HEIGHT: '身長(T)',
      WAITER_BODY_BUST: 'バスト(B)',
      WAITER_BODY_WAISTLINE: 'ウエスト(W)',
      WAITER_BODY_HIPLINE: 'ヒップ(H)',
      WAITER_BLOOD_TYPE: '血液型',
      WAITER_SIGN_TYPE: '星座',
      WAITER_SIGN_TYPE_ARIES: '牡羊座',
      WAITER_SIGN_TYPE_TAURUS: '牡牛座',
      WAITER_SIGN_TYPE_GEMINI: '双子座',
      WAITER_SIGN_TYPE_CANCER: '蟹座',
      WAITER_SIGN_TYPE_LEO: '獅子座',
      WAITER_SIGN_TYPE_VIRGO: '乙女座',
      WAITER_SIGN_TYPE_LIBRA: '天秤座',
      WAITER_SIGN_TYPE_SCORPIO: '蠍座',
      WAITER_SIGN_TYPE_SAGITTARIUS: '射手座',
      WAITER_SIGN_TYPE_CAPRICORN: '山羊座',
      WAITER_SIGN_TYPE_AQUARIUS: '水瓶座',
      WAITER_SIGN_TYPE_PISCES: '魚座',
      WAITER_INTRODUCE: '紹介',
      PLEASE_UPLOAD_AVATAR: 'アバターをアップロードしてください',
      WAITER_RESUME_INFO: 'Q&A',
      WAITER_RESUME_QUESTION: '質問',
      WAITER_RESUME_ANSWER: '回答',
      WAITER_RESUME_KEY_ERR: '質問を入力してください',
      WAITER_RESUME_VALUE_ERR: '回答を入力してください',
      WAITER_CALENDAR_WORK_STATUS: '出勤状況',
      WAITER_CALENDAR_WORK_STATUS_DEFAULT: '未設定',
      WAITER_CALENDAR_WORK_STATUS_WORK: '出勤',
      WAITER_CALENDAR_WORK_STATUS_REST: 'お休み',
      WAITER_CALENDAR_MONDAY: '月曜日',
      WAITER_CALENDAR_TUESDAY: '火曜日',
      WAITER_CALENDAR_WEDNESDAY: '水曜日',
      WAITER_CALENDAR_THURSDAY: '木曜日',
      WAITER_CALENDAR_FRIDAY: '金曜日',
      WAITER_CALENDAR_SATURDAY: '土曜日',
      WAITER_CALENDAR_SUNDAY: '日曜日',
      WAITER_CALENDAR_SETTING_TYPE: '日付タイプ',
      WAITER_CALENDAR_SETTING_TYPE_WEEK: '曜日',
      WAITER_CALENDAR_SETTING_TYPE_DAY: '日付指定',
      WAITER_CALENDAR_SETTING_WEEK: '適用曜日',
      WAITER_CALENDAR_SETTING_TIP_WORK: '未設定の日に勤務ステータスを設定する',
      WAITER_CALENDAR_SETTING_TIP_REST: '未設定の日に休息ステータスを設定する',
      WAITER_CALENDAR_SETTING_TYPE_ERR: '設定タイプを選択してください',
      WAITER_CALENDAR_SETTING_WEEK_ERR: '適用曜日を選択してください',
      WAITER_CALENDAR_SETTING_DATE_ERR: '時間範囲を選択してください',
      WAITER_CALENDAR_WORK_STATUS_ERR: '出勤ステータスを選択してください',
      CONSUME_INFO: "料金システム",
      PREFERENTIAL_INFO: "割引情報説明",
      CATEGORY_SHOP_NUM: "店舗数",
      NEW_SHOP_NUM: "総店舗数",
      BUSINESS_SHOP: "オープニング",
      MOUNTH_NEW_SHOP_NUM: "今月新たに追加",
      MOUNTH_CREATED_SHOP_NUM: "今月更新",
      SHOPAPPLY_EDIT: "店舗の掲載申請を編集します",
      ALL_SHOP_USED: "すべて店舗に適用",
      SHOP_CATEGOEY_VALID: "店舗のカテゴリは最大3つまで",
      POINT_CODE: "スタンプ用QRコード",
      SHOP_SIGNIN_GIVE_POINTS: "チェックイン時付与するポイント数",
      CHOOSE_ALLOW_ACTIVITY_BUY: 'イベントの購入許可を選択ください',
      CHOOSE_ALLOW_BUY: '商品の許可を選択ください',
      NAME_TIPS: "店舗名は絵文字利用できません",
      POINT_USE_SETTING: 'JPマネー、ポイン利用設定',
      FREE_POINT: 'JPポイント',
      PAID_POINT: 'JPマネー',
      MAX_DEDUCTION: '利用上限',
      POINT_USE_TIPS: '-1は全額ポイント使用可能を意味します',
      GOODS_REBATE_AMOUNT: '推薦購入インセンティブ率(キャッシュバックのパーセンテージを入力してください)',
      PLEASE_CHECK: '少なくとも一つの利用設定を選択してください',
    },
    room: {
      CREATE_COMPARTMENT: 'VIP RESERVATIONを作成',
      NAME: 'VIP RESERVATION名',
      PLEASE_NAME: 'VIP RESERVATION名を入力してください',
      USERS: '人数',
      PLEASE_MIN_USERS: '最小人数を入力してください',
      PLEASE_MAX_USERS: '最大人数を入力してください',
      PRICE: '基本料金',
      PLEASE_PRICE: '基本料金を入力してください',
      EXTRA_PRICE: '追加料金',
      REFUND_FEE: '返金手数料',
      PLEASE_FEE: '手数料のパーセンテージを入力してください',
      EACH_PERSON: '一人当たり',
      UN_APPOINTMENT: '予約不可',
      APPOINTMENT: '予約可',
      APPOINTMENTED: '予約済み',
      SETTINGS: '一括設定',
      CREATE_TITLE: '予約可能時間帯の設定',
      OPEN_OFF_TIME: '開始・終了時間',
      TIME_SETTING: '時間帯設定',
      PLEASE_TIME_SETTING: '時間帯を選択してください',
      TIME_SETTING_ERROR: '時間帯の選択は重複できません',
    },
    activitys: {
      ACTIVITY_LIST: "イベント一覧",
      ACTIVITY_ONE_PHOTO: "イベントメイン画像",
      ACTIVITY_NAME: "イベント名",
      ACTIVITY_NAME_CLICK: "イベント名（クリック数 / いいね数）",
      ACTIVITY_CREATE: "新規イベント",
      ACTIVITY_SHOP: "所属店舗",
      PLEASE_ACTIVITY_SHOP: "所属店舗を選択してください",
      ACTIVITY_REGIONS: "リージョン",
      ACTIVITY_PRAISE: "いいね数",
      ACTIVITY_MUSIC: "音楽ジャンル",
      ACTIVITY_TIME: "イベント時間",
      ACTIVITY_DETAIL: "イベント情報",
      ACTIVITY_DESC: "イベント詳細",
      ACTIVITY_TYPE: "イベントタイプ",
      ACTIVITY_TEL: "イベント電話番号",
      ACTIVITY_SITE: "イベント住所",
      PLEASE_ACTIVITY_NAME: "イベント名を入力してください",
      PLEASE_ACTIVITY_DESC: "紹介文を入力してください",
      ACTIVITY_PRICE_MALE: "男性入場料",
      ACTIVITY_PRICE_FAMALE: "女性入場料",
      PLEASE_ACTIVITY_PRICE: "イベント価格を入力してください",
      ACTIVITY_VIRTUAL_PRAISE: "仮いいね数",
      PLEASE_VIRTUAL_PRAISE: "仮いいね数を入力してください",
      ACTIVITY_AGAIN_PRICE: "再入場料金",
      PLEASE_AGAIN_PRICE: "再入場料金を入力してください",
      WHETHER_REFUND: "返金対応有無",
      PLEASE_WHETHER_REFUND: "返金期限を入力してください",
      RETURNABLE: "返金可能",
      NO_RETURNABLE: "返金不可",
      REFUND_HALF: "半額返金対応",
      REFUND_NO: "返金できません",
      REFUND_ALL: "全額返金対応",
      ACTIVITY_PUTAWAY: "公開/公開しない",
      ACTIVITY_TOP_PUTAWAY: "公開する",
      ACTIVITY_up_PUTAWAY: "公開しない",
      PUTAWAY_DAY: "日前",
      DISCOUNTS: "割引情報",
      DISCOUNTS_CONDITION: "割引条件",
      DISCOUNTS_LIST: "割引一覧",
      DISCOUNTS_DESC: "割引説明",
      PLEASE_DISCOUNTS_DESC: "割引紹介文を入力してください",
      DISCOUNTS_PRICE: "割引金額",
      PLEASE_DISCOUNTS_PRICE: "割引金額を入力してください",
      DISCOUNTS_SHARE: "併用可/不可",
      PLEASE_DISCOUNTS_SHARE: "併用可否を選択してください",
      DISCOUNTS_GIVE: "割引設定",
      PLEASE_DISCOUNTS_GIVE: "割引設定を選択してください",
      GIVE_DESC: "サービス詳細",
      GIVE_DRINK: "ドリンク詳細",
      DISCOUNTS_UNLIMITED: "ドリンク飲み放題",
      DISCOUNTS_CUP: "杯",
      PHOTO_FIVE: "画像は最大５枚まで",
      PLEASE_ACTIVITY_NAME_DESC: "イベント情報を入力してください",
      PLEASE_ACTIVITY_NAME_LENGTH: "イベント名に最大文字数を超えました",
      ACTIVITY_AGAIN_PRICE_SEVEN: "再入場料は７桁までに入力してください",
      ACTIVITY_AGAIN_PRICE_INTEGER: "再入場料金は整数字を入力してください",
      ACTIVITY_TICKET_COUNT:
        "作成するチケット数を入力してください。整数のみです。",
      ACTIVITY_TICKET_THANONE: "作成するチケット数は1以上でなければなりません",
      WHETHER_REFUND_TIME: "返金の有効期間を入力してください",
      PLEASE_ACTIVITY_PUTAWAY: "公開状態を選択してください",
      ACTIVITY_NOT_SHOP: "このイベントは店舗に属しません",
      ACTIVITY_MUSIOCS_TYPE: "音楽のタイプを選んでください",
      PLEASE_ACTIVITY_MUSIOCS_TYPE: "最大3種類の音楽タイプ",
      ACTIVITY_COPY: "このイベントをコピーしますか？",
      PLEASE_ACTIVITY_TYPE: "イベントのタイプを選択",
      PLEASE_WHETHER_NBMER: "返金用日数は数字で入力してください",
      WHETHER_REFUND_PLEASE: "返金可否を選択してください",
      DISCOUNTS_GIVEA_DRINK: "無料ドリンク",
      DISCOUNTS_GIVEA_MERGE: "併用する",
      DISCOUNTS_GIVEA_NO_MERGE: "併用しない",
      DISCOUNTS_TYPE: "割引タイプ",
      DISCOUNTS_OTHER_TYPE: "その他",
      DISCOUNTS_GIVEA_DRINK_SET: "無料ドリンク設定",
      DISCOUNTS_GIVEA_GIVE_SETONE: "サービス内容設定1",
      DISCOUNTS_GIVEA_GIVE_SETTOW: "サービス内容設定2",
      DISCOUNTS_CUP_NUMBER: "ドリンクは何杯まで無料",
      GIVEA_DRINK_NUMBER: "無料ドリンク杯数は数字しか入力できません",
      PLEASE_CUP_NUMBMER: "無料ドリンク杯数を入力してください",
      PLEASE_DISCOUNTS_DESC: "割引説明を入力してください",
      PLEASE_DISCOUNTS_DESC_LENGHT: "割引説明は最大文字数を超えています",
      PLEASE_DISCOUNTS_GENDER: "性別を選んでください",
      PLEASE_DISCOUNTS_TYPE: "割引タイプを選んでください",
      PLEASE_DISCOUNTS_TYPE_NAME: "ほかのタイプを入力してください",
      PLEASE_PRICE: "割引金額を入力してください",
      PLEASE_DISCOUNTS_ANDUSE: "併用有無を選んでください",
      ACTIVITY_GUEST: "スペシャルゲストはいますか？",
      ACTIVITY_PAY: "イベントチケットのオンライン購入を許可しますか",
      ACTIVITY_RANKING: "ランキング",
      ACTIVITY_TICKET: "イベントチケット",
      ACTIVITY_TICKET_LIST: "チケット一覧",
      ACTIVITY_GENERATE_TICKET: "チケットを生成する",
      ACTIVITY_TICKET_NAME: "受取人ニックネーム",
      ACTIVITY_USAGE_QUANTITY: "使用済み/未使用",
      ACTIVITY_GIT_AMOUNT: "送付済み/未送付",
      ACTIVITY_OPERATION: "操作",
      ACTIVITY_ID: "ID",
      ACTIVITY_GENERATE_NUM: "生成数",
      ACTIVITY_TICKET_COLLECTOR: "受取人",
      ACTIVITY_CONFIRM: "生成しますか",
      ACTIVITY_PRICE: "イベント料金",
      ACTIVITY_PLEASE_INPUT: "入力してください",
      ACTIVITY_DISCOUNTS: "割引",
      ACTIVITY_DETERMINE: "确定",
      ACTIVITY_INPUT_NUMBER: "生成数を入力してください",
      ACTIVITY_INPUT_NUMBER_TEST: "生成数は1以上でなければなりません",
      ACTIVITY_ADD_TICKETS: "受取人を追加してください",
      ACTIVITY_DETERMIN_TICKETS: "チケットを生成しますか",
      ACTIVITY_NO_DISCOUNTS: "割引情報なし",
      ACTIVITY_SHEET: "発券数",
      OPEN_SPECIAL: "キャンペーンを実施しますか？",
      SPECIAL_OFFER_MAN: "男性キャンペーン",
      SPECIAL_OFFER_WOMAN: "女性キャンペーン",
      SPECIAL_LINE_PURCHASE: "イベントの購入設定",
      ALLOW_ACTIVITY_PURCHASE: "イベントの購入を有効にする",
      NOALLOW_ACTIVITY_PURCHASE: "イベントの購入を無効にする",
      SPECIAL_END: "キャンペーン終了時間",
      SPECIAL_TITLE: "キャンペーンタイトル",
      SPECIAL_DESC: "キャンペーン説明",
      PLEASE_SPECIAL_TITLE: "キャンペーンタイトルを入力してください",
      PLEASE_SPECIAL_DESC: "キャンペーン説明を入力してください",
      PLEASE_TIME_END: "キャンペーン終了時間は現在時間時刻より後です",
      PLEASE_SPECIAL_TIME_END: "キャンペーン終了時間を選んでください",
      ACTIVITY_INVENTORY: "チケット在庫数",
      ACTIVITY_STATUS_SET: "イベントの状態設定",
      ACTIVITY_SUCCESS: "コピー成功",
      ISDISCOUNT: "他の割引と併用可否",
      ADD_ACTIVITY_CATEGORY: "活動カテゴリーを作成",
      CATEGORY_NAME: "カテゴリー名",
      PLEASE_CATEGORY_NAME: "カテゴリー名を入力してください",
      LOWER_CATEGORY_LIST: "下位カテゴリー一覧",
      CHECK_ACTIVITY_ORDER: "イベント注",
      ADD_CHILDREN_CATEGORY: "下位カテゴリーを追加",
      CREATE_ORDER: "注文を生成する",
      CURRENT_ORDER: "このイベントの注文",
      IS_CANCEL_ORDER: "支払期限(10分)自動キャンセル",
      ACTIVITY_CLASS: "イベントの分類",
      PLEASE_ACTIVITY_CLASS: "イベントの分類を選択してください",
      IS_BUY_TIME: "イベント購入時間を有効にしますか",
      IS_GIVEN: "チケットの転送可否",
      IS_QUOTA: "チケットの発売に制限有無",
      IS_BUY_OPEN_TIME: "イベント購入開始時間",
      IS_BUY_OFF_TIME: "イベント購入終了時間",
      CHOOSE_BUY_OPEN_TIME: 'イベント購入開始時間',
      CHOOSE_BUY_OFF_TIME: 'イベント購入終了時間',
      QUOTA_AMOUNT: "最大チケット数",
      PLEASE_TEST_QUOTA_AMOUNT:
        "チケットの前売り枚数は0以上の正の整数でなければならない",
      PLEASE_QUOTA_AMOUNT: "チケットの最大購入数を入力してください",
      PLEASE_PURCHASE_TIME: "イベント購入終了時間は開始時間より後です",
      IS_LIMITED_ENTRY: "入場時間を厳しく制限しますか",
      LIMITED_ENTRY_AT: "イベント最終入場時間",
      IS_VIP_PRICE: "ゴールドメンバー価格を有効にしますか",
      VIP_PRICE_END_AT: "ゴールドメンバー終了時間",
      VIP_PRICE_TITLE: "ゴールドメンバータイトル",
      VIP_PRICE_DESC: "ゴールドメンバー説明",
      VIP_PRICE_FEMALE: "女性ゴールドメンバー入場料",
      VIP_PRICE_MALE: "男性ゴールドメンバー入場料",
      SPECIAL_GUEST: "スペシャルゲスト",
      ACTIVITY_COUNTRY: "全エリアまで表示設定",
      SPECIAL_ACTIVITY: "スペシャルイベント",
      VIP_DESC: "ゴールドメンバー説明",
      PLEASE_VIP_TITLE: "ゴールドメンバー価格タイトルを入力してください",
      PLEASE_VIP_DESC: "ゴールドメンバー価格の説明を入力してください",
      ACTIVITY_SESSION: "イベントセッション",
      ACTIVITY_GROUPS: "イベントグループ",
      ACTIVITY_GROUPS_NAME: "イベントグループタイトル",
      IS_OPEN_ACTIVITY_SESSION: "イベントセッションを作成しますか",
      ACTIVITY_SESSION_NAME: "イベントセッションタイトル",
      ACTIVITY_SESSION_DESC: "イベントセッション説明",
      OPEN_VIP: "ゴールドメンバー価格スイッチ",
      PLEASE_SELECT_DATE: "日付を選択してください",
      MALE_STOCK: "男性在庫数（制限なし -65535）",
      FEMALE_STOCK: "女性在庫数（制限なし -65535）",
      SESSION_STOCK: "セッション在庫数（制限なし -65535）",
      IS_RNTER_PIE: "再入場可否",
      PURCHASE_SET: "購入関連設定",
      TOCKET_SET: "チケット関連設定",
      OTHER_SET: "その他設定",
      STOCK: "チケット数",
      ACTIVITY_EXPLAIN: "年齢制限説明",
      PLEASE_EXPLAIN: "年齢制限説明を入力してください",
      PLEASE_SELECT_USERS: "チケットの受取人を選択",
      REFUND_VALID_NUM: "返金有効期限は数字のみ",
      ACTIVITY_OPEN_TIME: "イベント開始時間",
      ACTIVITY_OFF_TIME: "イベント終了時間",
      ACTIVITY_CATAGORY_NUM: "イベント数",
      ONLINE_PURCHASE_POINT:
        "オンライン決済ポイント還元設定（還元ポイント％入力）",
      PLEASE_ONLINE_PURCHASE_POINT: "還元ポイント％入力",
      OFFLINE_PURCHASE_POINT: "スタンプ設定",
      RETURN_POINT: "還元ポイント数",
      VALID_ONLINE_PURCHASE_POINT:
        "還元ポイントを０より大きい正の整数のみ入力できます",
      RETURN_POINT_TIME: "還元時間",
      PRINT_NUM: "スタンプ数",
      VALID_PRINT_NUM: "スタンプ数は０以上の数字を入力",
      EXCHANGE_NUM: "交換数",
      EXCHANGE_TIME: "交換時間",
      NOT_DELETE_ACTIVITY: "チケット販売中のイベントを削除できません",
      ALL_CLOSE: "転売不可",
      ALL_OPEN: "転売可",
      PART_OPEN: "一部転売",
      ADD_ARTIST: "JPオフィシャル会員追加",
      ARTIST: "JPオフィシャル会員",
      PLEASE_ARTIST:
        "JPオフィシャル会員のニックネームまたは電話番号を入力します",
      ARTIST_REFERRAL: "JPオフィシャル会員紹介で還元ポイント設定",
      RETURN_MONEY_TITLE: '販売者インセンティブ設定',
      PLEASE_ONLINE_PURCHASE_POINT: '％',
      PLEASE_RETURN_MONEY: '¥',
      OFFLINE_PURCHASE_POINT: 'スタンプ設定',
      RETURN_POINT: '還元ポイント数',
      RETURN_MONEY: 'インセンティブ額',
      VALID_ONLINE_PURCHASE_POINT: '還元ポイントを０より大きい正の整数のみ入力できます',
      RETURN_POINT_TOTAL: '還元ポイント合計',
      RETURN_POINT_PAID_AMOUNT: '支払い金額合計',
      RETURN_POINT_TIME: '還元時間',
      PRINT_NUM: 'スタンプ数',
      VALID_PRINT_NUM: 'スタンプ数は０以上の数字を入力',
      EXCHANGE_NUM: '交換数',
      EXCHANGE_TIME: '交換時間',
      NOT_DELETE_ACTIVITY: 'チケット販売中のイベントを削除できません',
      ALL_CLOSE: '転売不可',
      ALL_OPEN: '転売可',
      PART_OPEN: '一部転売',
      ADD_ARTIST: 'JPオフィシャル会員追加',
      ARTIST: 'JPオフィシャル会員',
      PLEASE_ARTIST: 'JPオフィシャル会員のニックネームまたは電話番号を入力します',
      ARTIST_REFERRAL: 'JPオフィシャル会員紹介で還元ポイント設定',
      VALID_OFFLINE_PURCHASE_POINT: 'スタンプ数は0以上を入力してください',
      IS_COMBINE: "会員料金一括表示",
      GROUP_COPY: "このグループをコピーしますか？",
      OPEN_LAST: "LAST表記ON",
      OPEN_PRICE_SET: "価格設定ON",
      COEXIST_WITH_ORIGINAL_ACTIVITY_PIICE: "イベントの原価と同時存在",
      SET_UP: "設定",
      SPECIAL_SETTINGS: "スペシャル価格の設定",
      PURCHASE_TIME_SETTING: "購入時間制限の設定",
      PAID_MEMBER_PICE_SETTING: "有料会員料金を設定",
      PURCHASE_RESTRICTION_SETTINGS: "購入制限の設定",
      ACTIVITYS_NOTE: '注意事項',
      OPEN_TICKET_INDEX: '整理券',
      TICKET_INDEX_MUST_GREATER_0: '整理券枚数は0以上に設定',
      ORDER_REMARKS: '備考欄',
      ORDER_REMARKS_NAME: '備考欄項目',
      PLEASE_ORDER_REMARKS_NAME: '必要な項目を入力してください',
      TIME_TIPS: '注意：公開状態切り替え時間 <= 開始＆終了時間',
      TIPS_REBATE: 'チケット販売後、報酬はすぐ記録されますが、出⾦可能はイベント終了後です。（システムの⾃動チェックは1時間ごとなので、反映が遅れる場合があります）',
      TIPS_STOCK1: '支払期限(10分)自動キャンセルONにする',
      TIPS_STOCK2: 'イベントをオフラインして編集（オフライン時間は10分以上待機）',
      TIPS_STOCK3: 'イベント内容を変更する際、在庫数を一切変更しない ',
      TIPS_COPY: '※コピーした内容は保存してから有効になります',
      HAND_FEE: '手数料（円）',
      HAND_FEE_ERROR_MSG: '手数料は0以上の整数のみ入力可能です',
      SESSION_INFO: 'セッション情報',
      DISPLAY_GROUP:'グループ',
      DISPLAY_CALENDAR:'カレンダー',
      SIRCLE_SET: '繰り返し設定',
      SIRCLE_TIPS: '繰り返しで作成されたセッションを変更する必要がある場合は、リストで日付をフィルターしてから個別に変更してください。作成時間帯などの関連パラメータに注意してください。',
      SIRCLE_TIMES: '繰り返し時間範囲',
      DAILY: '毎日',
      WEEKLY: '毎週',
      MONTHLY: '毎月',
      MONDAY: '月曜日',
      TUESDAY: '火曜日',
      WEDNESDAY: '水曜日',
      THURSDAY: '木曜日',
      FRIDAY: '金曜日',
      SATURDAY: '土曜日',
      SUNDAY: '日曜日',
      REBATE_PROPORTION: 'キャッシュバックの割合は0～100の正整数のみ使用できます',
      STATUS_NOTICE1: '上下架时间优先于上下架开关, 打开开关时确认上下架时间',
      STATUS_NOTICE2: '系统每小时会自动执行上下架操作',
      STOCK_CONFIRM: '在庫変更の確認',
      STOCK_TIP1: '在庫を編集している間に在庫が変更される可能性もありますので、ご注意ください',
      STOCK_TIP2: '在庫を次の値に変更してよろしいですか',
    },
    orders: {
      ORDERS_LIST: "注文一覧",
      ORDERS_NUMBER: "注文NO.",
      ORDERS_EXP_DETAIL: "注文明細をダウンロード",
      ORDERS_PRICE: "注文の元金額",
      ORDERS_PAYMENT_PRICE: "支払済金額",
      ORDERS_NO_PRICE: "未払い金額",
      ORDERS_STATUS: "注文ステータス",
      ORDERS_PAID: "支払済み",
      ORDERS_UNPAIED: "未払い",
      ORDERS_NOT_REFUND: "未払い戻し",
      ORDERS_REFUND: "返金手続き中",
      ORDERS_REFUND_FINISH: "返金完了",
      ORDERS_SYSTEM_REFUND: '自動返金',
      ORDERS_REFUND_REJECT: "返金不可",
      ORDERS_FINISH: "完了",
      ORDERS_CREATED: "注文済み",
      ORDERS_CANCEL: "取消完了",
      ORDERS_PAID_HALF: "一部支払済み",
      ORDERS_PAST: "有効期限切れ",
      ORDERS_DETAIL: "注文情報",
      ACTIVITY_ORIGNAL_PRICE: "イベント通常料金",
      ACTIVITY_DISCOUNT_PRICE: "イベントセール",
      ORDERS_DISCOUNTS_PRICE: "注文の割引合計",
      ORDERS_REALITY_PRICE: "注文の実績金額",
      ORDERS_UP_TIME: "注文時刻",
      ORDERS_PAYMENT_TIME: "支払い時刻",
      ORDERS_ACTION: "注文操作",
      PAYMENT: "支払い",
      REFUND: "返金",
      PAYMENT_HALF: "一部支払済み",
      REFUND_AGREE0: "返金可能",
      REFUND_REJECT: "返金不可",
      ORDERS_OFF: "注文を閉じる",
      ORDERS_VAIN: "無効",
      ORDERS_LOG: "注文ログ",
      ORDERS_LOG_RECORD: "操作履歴",
      OPERATOR: "実行者",
      TIME: "時間",
      DETERMINE_REFUND: "返金確定",
      ORDERS_STATISTICS: "注文集計",
      ORDERS_LOG_REMARKS: "操作メモを入力してください",
      ORDERS_GOD_PRICE: "正しい価格を入力してください",
      ORDERS_ACTUAL_PRICE: "支払い金額は価格を超えてはいけません",
      ORDERS_DETERMINE_REFUND: "返金手続きをしますか？",
      ORDERS_GOD_DETERMINE_REFUND: "返金を確定しますか",
      ORDERS_NOT_DETERMINE_REFUND: "返金をキャンセルしますか",
      ORDERS_NOT: "閉じますか？",
      ORDERS_BASIC: "基本情報",
      DISCOUNTS_CHOICE: "割引条件",
      DISCOUNTS_NOT: "本イベントは割引がありません",
      PLEASE_ORDERS_PRICE: "金額を入力してください",
      ORDERS_DREFUND: "支払いを確定しますか？",
      MAKE_CANCEL: "取り消しますか?",
      ORDERS_PRICE_INTEGER: "返金額は0以上でなければなりません",
      ORDERS_NOT_DETERMINE: "返金額は決済済み金額を超えてはいけません",
      ORDERS_GIVE: "転送済み",
      ORDERS_GIVING: "転送中",
      CONFIRM_TRANSFER: "受け取り確認",
      CANCEL_TRANSFER: "転送をキャンセル",
      ORDERS_ACTUAL_NAME: "店舗名を入力してください",
      ORDERS_SHOP_NAME: "イベント名を入力してください",
      ORDERS_GIVE_PEOP: "贈り主",
      ORDERS_GIVER: "受取人",
      ORDERS_QRCODE: "注文QRコード",
      ORDERS_PRICE_TOTAL: "合計金額",
      ORDERS_NUMBER_TOTAL: "注文数",
      ORDERS_PAYPRICE_TOTAL: "支払済み金額",
      ORDERS_UP_START_TIME: "注文開始時間",
      ORDERS_UP_END_TIME: "注文終了時間",
      ORDERS_GIVE_START_TIME: "プレゼント開始時間",
      ORDERS_GIVE_END_TIME: "プレゼントス終了時間",
      ORDERS_PAY_START_TIME: "支払い開始時間",
      ORDERS_PAY_END_TIME: "支払い終了時間",
      ORDERS_EXPORT_MANY: "出力する注文は10,000件まで",
      ORDERS_GIVE_PERIOD: "転送中",
      PAYMENT_LOG: "支払い履歴",
      PAYMENT_WAY: "決済手段",
      PAYMENT_PRICE: "決済金額",
      PAYMENT_TIME: "決済時間",
      SURE_GIVEN: "受取ますか？",
      CANCEL_GIVEN: "キャンセルしますか?",
      VIP_PRICE: "有料会員料金",
      APPLE_PAY: "Apple Pay",
      IOS_PURCHASE: "Apple Pay IAP",
      ANDROID_PURCHASE: "Google Pay IAP",
      WEBMONEY_QUICK_APP: "WebMoney",
      POINTS_PAY: "ポイント決済",
      ALIPAY: "アリペイ",
      WXPAY: "WeChat Pay",
      PAYPAY: 'PayPay',
      PAYPAL: 'PayPal',
      GOOGLE_PAY: "Google Pay",
      JAPAN_PAY: "カード決済",
      OFFLINE_PAY: "現地払い",
      PLATFORM_PAY: "プラットフォーム決済",
      UMS_PAY: "UMS決済",
      ORDER_PAYMENT: "支払済み額",
      FREE_ORDER: "無料注文",
      PAY_STATUS: "支払いステータス",
      REFUND_STATUS: "払い戻しのステータス",
      VALID: "有効",
      INVALID: "無効",
      PAY_POINT: "支払済みポイント数",
      REFUND_PRICE: "払い戻し済みの金額",
      DELETE_TIME: "削除時間",
      REFUND_TIME: "払い戻し時間",
      UPDATE_TIME: "最後操作更新時間",
      ACTION_FROM: "操作元",
      DEVICE_ID: "デバイスID",
      OTHER_TX_SN: "第三者取引フロー番号",
      OTHER_TX_ORDER_SN: "第三者取引注文番号",
      PAYMNET_PLATEFORM: "支払い手段",
      PAYMENT_TYPE: "支払いタイプ",
      ACTION_WAY: "操作モード",
      PLEASE_WRITE_SN: "注文番号を入力してください",
      SERIAL_NUM: "取引番号",
      REFERRAL_INFOR: "紹介者情報",
      RECOMMED_CODE: "招待コード",
      PAY_DETAIL: "備考情報",
      PAY_FAIL: "支払いに失敗しました",
      GOODS_SN: '商品コード',
      GOODS_NUM_TOTAL: '商品数',
      USAGE_STATUS: '使用ステータス',
      PRODUCT_INFO: '商品情報',
      PRODUCT_NAME: '商品名',
      USER_ID: 'ユーザーID',
      USERGOODS_CREATE_START: '商品创建开始时间',
      USERGOODS_CREATE_END: '商品创建结束时间',
      USERGOODS_GIVEN_LOG: '商品赠送日志',
      USERGOODS_VALID_START: '有效期开始时间',
      USERGOODS_VALID_END: '有效期结束时间',
      USERGOODS_CREATE_TIME:'商品创建时间',
      GOODS_STATUS: '商品状態'
    },
    member: {
      DJ_USERS: "認定DJユーザー",
      HOTONLINE_USERS: "認定インフルエンサー",
      SOURCE_FRIEND_TRANSFER: "転送",
      SOURCE_ORDER_REFUND: "注文の返金",
      SOURCE_ADMIN_MODIFIED: "管理者修正",
      SOURCE_ORDER_REBATE: "購入によるポイント還元",
      SOURCE_STORE_ONSITE: "店舗ポイント利用",
      SOURCE_ONLINE_TOPUP: "オンラインチャージ",
      SOURCE_ORDER_PURCHASE: "イベントの購入",
      SOURCE_GIFT_PURCHASE: "投げ銭ギフト",
      SOURCE_NEW_USER: "新規登録",
      SOURCE_DAILY_LOGIN: "毎日チェックイン",
      SOURCE_LIVE_PURCHASE: "配信の購入",
      SOURCE_REFERRAL_COIN: "紹介による登録",
      SOURCE_VD_TOPUP: "入金機チャージ",
      SOURCE_GAME: "ゲームから貰った",
      SOURCE_MERCHANT_TOPUP: "スタッフチャージ",
      SOURCE_EXPIRED: "期限切れ",
      VIP_PRIVILEGE: "有料会員特典",
      MEMBER_APPLY_INFO: "申請情報",
      REMAINING_BALANCE: "残高",
      IM_BLOCKED_OPEN: "コメントは解禁する",
      IM_BLOCKED_CLOSED: "コメントは禁止する",
      MEMBERS_AVAILABLE_POINT: "利用可能なポイント",
      POINT_VALID_DAY: "ポイントの有効期限",
      MEMBERS_LIST: "会員一覧",
      MEMBERS_CREATE: "新規会員",
      MEMBERS_NICKNAME: "ニックネーム",
      MEMBERS_NAME: "名前",
      MEMBERS_SEX: "性別",
      MAN: "男",
      WOMAN: "女",
      SECRECY: "公開しない",
      MEMBERS_ENROLL: "登録時間",
      MEMBERS_POINT: "ポイント数",
      MEMBERS_STATUS: "ステータス",
      ALREADY_AUDIT: "審査済み",
      ALREADY_NOT: "審査拒否",
      ALREADY_NONE: "未審査",
      MEMBERS_BLACKLIST: "ブラックリスト",
      MEMBERS_BLACKLIST_LIST: "ブラックリスト一覧",
      BLACKLIST_HAVE: "ブラックリストレコードあり",
      BLACKLIST_NOT: "ブラックリストレコードなし",
      MEMBERS_IDENTITY: "身分証明書",
      MEMBERS_IDENTITY_DETAIL: "身分証情報",
      ALREADY_UPLOADING: "アップロード済み",
      NOT_UPLOADING: "未アップロード",
      MEMBERS_DETAIL: "会員情報",
      MEMBERS_BIRTHDAY: "生年月日",
      MEMBERS_PROFESSION: "職業",
      MEMBERS_STATE: "国籍",
      ADDRESS_COUNTY: "住所ー都/道/府/県",
      ADDRESS_CITY: "住所ー市区町村",
      ADDRESS_STREET: "住所ー街／丁目",
      ADDRESS_ADDITIONAL: "住所ーその他",
      ADDRESS_POSTCODE: "郵便番号",
      COMPLETENESS: "完成度",
      BADNESS_TIME: "違反記録時間",
      BLACKLIST_CREATE: "ブラックリストを作成",
      COMMENT: "メモ",
      ADD_BLACKLIST_HAVE: "ブラックリストに記録を追加する",
      DOCUMENTING: "記録時間",
      MEMBERS_EXP: "メンバーのエクスポート",
      MEMBERS_LAST_TIME: "前回ログイン時間",
      VERIFICATION_IDENTITY: "身分証明書の認証",
      PLEASE_MEMBERS_NICKNAME: "ニックネームを入力してください",
      PLEASE_MEMBERS_NAME: "名前を入力してください",
      PLEASE_MEMBERS_JID: "JIDを入力してください",
      PLEASE_MEMBERS_NICKNAME_LENGTH: "ニックネームの文字数は３０文字以内",
      PLEASE_MEMBERS_NAME_LENGTH: "名前を３０文字以内にしてください",
      ADDRESS_COUNTY_LENGTH: "都道府県に入力文字数制限を超えました",
      ADDRESS_CITY_LENGTH: "市区町村に入力文字数制限を超えました",
      ADDRESS_STREET_LENGTH: "街／丁目に入力文字数制限を超えました",
      ADDRESS_ADDITIONAL_LENGTH: "その他情報に入力文字数制限を超えました",
      ADDRESS_POSTCODE_LENGTH: "郵便番号最大は８文字となります",
      MEMBERS_IDENTITY_ZF: "身分証明書を両面の画像が必要です",
      MEMBERS_SEX_OPEN: "性別を公開しますか",
      MEMBERS_TEL_OPEN: "電話番号を公開しますか",
      PLEASE_ACTIVITY: "イベントを選択してください",
      PLEASE_MEMBERS_DESC: "説明を入力してください",
      ADD_MEMBER: "会員レベルを作成",
      RECHARGE_PEOPLE: "課金人数",
      VALIDIY: "有効時間",
      MEMBERS_GRADE_NAME: "会員レベル名",
      MEMBERS_NUMBER: "クーポン数を入力してください",
      YEAR: "年間",
      MOUTH: "か月",
      DAY: "日",
      MEMBERS_PRIVILEGE: "会員特典",
      ADD_MEMBERS_PRIVILEGE: "特典追加",
      MEMBERS_IDENTITY_NULL: "このユーザは身分証をアップロードしていません",
      ALL_SHOPS_APPLY: "全店舗利用可能",
      SHOP_PICTURES: "画像を追加",
      JID_FORMAT:
        "J-IDは数字またはアルファベットのみ、且つ20桁を超えてはいけません",
      BAGDE: "バッジを有効にしますか",
      MEMBER_AVATER: "友達の写真",
      MENBERSHIP: "ゴールドメンバー(１か月) ",
      RELATED_PURCHARSE: "紐づいたアプリ内購入商品",
      MENBER_OFFICE_SWITCH: "JP認定会員",
      USER_STATUS: "会員認定ステータス",
      WOMAN_SWITCH: "ビューティー会員",
      SURE_MODIFY_POIONT: "ポイント数を編集しますか？",
      SURE_MODIFY_COIN: "コイン数を編集しますか？",
      POINT_RECORD: "ポイント履歴",
      COIN_RECORD: "コイン履歴",
      POINT_INFOR: "説明",
      BLACKLIST_RECORD: "ブラックリスト",
      FRIENDS_LIST: "友達リスト",
      UPLOAD_AVATAR: "画像をアップロード",
      TEST_POINT: "ポイント数は整数のみです（０可）",
      TEST_COIN: "コイン数は整数のみです（０可）",
      MAX_VALID: "有効時間は整数のみです",
      PLEASE_PIONT: "ポイント数を入力ください",
      PLEASE_COIN: "コイン数を入力ください",
      UAER_EMAIL: "メールアドレス",
      UAER_INFORMATION: "ユーザー情報",
      SCREEN_ITEMS: '絞込み項目',
      VIP_TYPE: '有料会員プラン',
      E_MAIL: 'メール',
      JID: 'JID',
      USER_ID: 'ユーザーID',
      RECOMMEND_STATUS: '招待状態',
      HAS_RECOMMENDER: '招待者あり',
      NO_RECOMMENDER: '招待者なし',
    },
    coupon: {
      PRICE_COUPON_PA: '価格',
      COUPON_NUMBER: "クーポン数",
      COUPON_TYPE: "クーポンタイプ",
      ROLES_USERS: "持ち主ユーザー",
      GIVE_AT: "転送時間",
      USED_AT: "使用時間",
      END_AT: "有効期限",
      VERIFICATION_NAME: "オレンジ端末店舗",
      ALL: "全て",
      NOT_USED: "未使用",
      ALREADY_USED: "使用済み",
      OVERDUED: "有効期限切れ",
      LOGO_PESOLVING: "解像度は300*300以下にしてください",
      SHOPS_NON_EXISTENT: "該当店舗は存在しません",
      COUPON_SEND_NUMBER: "発行枚数",
      COUPON_LIST: "クーポン一覧",
      COUPON_CREATE: "クラブを作成",
      COUPON_NAME: "クーポンタイプ",
      COUPON_TIME: "有效时间",
      COUPON_AMOUNT: "発行総数",
      COUPON_LOGO: "クーポン用ロゴ",
      COUPON_NUM: "クーポン数",
      ORDER_AMOUNT: "注文額",
      COUPON_AMOUNT_AMONG: "価格帯",
      COUPON_AMOUNT_MAX: "最高価格",
      COUPON_AMOUNT_MIN: "最低価格",
      CORRECT_COUPON_NUM: "正しいクーポン数を入力してください",
      COUPON_AMOUNT_MAX_NULL: "最高価格を入力してください",
      COUPON_AMOUNT_MIN_NULL: "最低価格を入力してください",
      COUPON_NULL: "クーポンを選んでください",
      EDIT_COUNT: "数量を編集",
      COUPON_NAME_LENGTH_MAX: "クーポン名の文字数制限を超えました",
      COUPON_NAME_NULL: "クーポン名を入力ください",
      COUPON_TIME_YEAR: "有効期間は10年を超えることはできません",
      COUPON_TIME_MONTH: "有効期間は30か月を超えることはできません",
      COUPON_TIME_DAY: "有効期間は365日を超えることはできません",
      COUPON_TIME_INT: "有効時間は整数のみです",
      PLEASE_SELECT_COUPONS: "添付するクーポンを選択してください",
      COUPONS_COUNT: "選択したクーポンに数を入力していない",
      PLEASE_COUNT: "数量を入力してください",
      PLEASE_DELETE_COUPONS: "削除するクーポン券を選択してください",
      USE_START_AT: "使用開始時間",
      USE_END_AT: "使用終了時間",
      CUPONS_CONTENT: "クーポン説明を設定",
      MERGE_SETTING: "多言語を一括設定します",
      SEND_SHOPS: "クーポンを受け取り可能な店舗"
    },
    articles: {
      ARTICES_LIST: "ドキュメント一覧",
      ADD_ARTICES: "ドキュメントを追加",
      ARTICES_NAME: "ドキュメント名",
      ARTICES_MESSAGE: "テキスト情報",
      ARTICES_TYPE: "ドキュメントタイプ",
      ARTICES_LANGUAGE: "ドキュメント言語",
      ABOUT_US: "About us",
      USER_PROTOCOL: "利用規約",
      PROCLAMATION: "お知らせ",
      ARTICES_HELP: "へルプ",
      GAME_RULE: "ゲームのルール",
      LOGINOUT_EXPLAIN: "アカウント削除説明",
      VIP_EXPLAIN: "JPゴールドメンバーのユーザー規約",
      ARTICES_CENTENT: "コンテンツ",
      PLEASE_ARTICES_NAME: "題名の入力してください",
      PLEASE_ARTICES_TYPE: "ドキュメントのタイプを入力してください",
      PLEASE_ARTICES_CENTENT: "内容を入力してください",
      PLEASE_ARTICES_LANGUAGE: "ドキュメント言語を記入してください",
      GIFT_NOTICE: "投げ銭説明",
      ID_PROTOCOL: "身分証法律規定"
    },
    appconfig: {
      APPCONFIG: "アプリ設定",
      APPCONFIG_PAY: "支払い設定",
      APPCONFIG_SHARE: "シェア設定",
      APPCONFIG_SPOT: "ポイント設定",
      APPCONFIG_COIN: "コインの交換設定",
      APPCONFIG_EXCHANGE: "交換用レート設定",
      APPCONFIG_EXCHANGE_TEXT: "人民元の為替レート",
      APPCONFIG_PAY_ALIPAY: "アリペイ",
      APPCONFIG_PAY_WECHAT: "WeChat Pay",
      APPCONFIG_PAY_LOCAL: "カード決済",
      APPCONFIG_SPOT_TXT: "1円あたり付与するポイント数",
      APPCONFIG_COIN_TXT: "1コインあたり付与する日本円",
      APPCONFIG_SPOT_ONE: "ポイントレートは1以上の整数でなければない",
      APPCONFIG_SPOT_ZS: "ポイントレートは整数でなければない",
      APPCONFIG_SPOT_DS: "コインで交換される日本円は1以上の整数でなければない",
      APPCONFIG_SPOT_YS: "コインで交換される日本円は整数でなければならない",
      APPCONFIG_LUCK: "コインくじ",
      APPCONFIG_IM: "IM設定",
      APPCONFIG_IM_UPG: "IM公開鍵アップロード",
      APPCONFIG_IM_UPS: "IM秘密鍵アップロード",
      APPCONFIG_DSF: "第三者SNSのリンク",
      VERSIONS_SET: "バージョン設定",
      VERSIONS_NUMBER: "強制更新用バージョン番号",
      VERSIONS_EXAMINE: "審査用更新バージョン番号",
      NEW_USER_FREE_VIP: "新規会員向けの無料ゴールドメンバー",
      IS_NEW_USER_FREE_VIP:
        "新規会員向けの無料ゴールドメンバーを有効にしますか",
      FEMALE_VALID_DAY: "ビューティー会員有効期限（日）",
      PLEASE_FEMALE_VALID_DAY: "ビューティー会員有効期限は整数のみです",
      DAY_LOGIN_COIN: "チェックインボーナス",
      NEW_USER_REGISTER_COIN: "新規ユーザーにコインを付与する",
      IS_OPEN_DAY_LOGIN: "チェックインボーナスを有効にしますか？",
      IS_OPEN_NEW_USER: "新規ユーザーにコインのプレゼントを有効にしますか？",
      DAY_LOGIN_COIN_NUM: "チェックインボーナスコイン数",
      NEW_USER_REGISTER_COIN_NUM: "新規ユーザーに贈るコイン数",
      PLEASE_DAY_LOGIN_COIN_NUM: "チェックインボーナスは整数のみです",
      PLEASE_NEW_USER_REGISTER_COIN_NUM:
        "新規ユーザーに贈るコイン数は整数のみです",
      RECOMMED_REGISTER_COIN: "紹介者にコイン付与",
      IS_OPEN_RECOMMED_REGISTER_COIN:
        "紹介者にコインのプレゼントを有効にしますか？",
      RECOMMED_REGISTER_COIN_NUM: "紹介者に付与するコイン数",
      PLEASE_RECOMMED_REGISTER_COIN_NUM:
        "紹介者に付与するコイン数は整数のみです",
      OPREATE_SET: "運用設定",
      PLEASE_WITER_RATE: "為替レートを入力してください",
      PLEASE_COIN_PRIZE: "コインの金額を入力してください",
      SYSTEM_SET: "システム設定",
      GOOGLE_KEY: "グーグルジオコードキーを入力してください",
      CACHE_OPEN: "キャッシュ管理",
      REGION_CACHE: "リージョンキャッシュ",
      GET_REGION_CACHE: "リージョンキャッシュを取得する",
      OPEN_SHOP_REGION: "オープンストアエリアキャッシュ",
      GET_OPEN_SHOP_REGION: "オープンストアエリアキャッシュを取得する",
      TEL_REGION: "市外局番キャッシュ",
      GET_TEL_REGION: "市外局番キャッシュを取得",
      IM_MENBER_REGION: "IMメンバー情報",
      GET_IM_MENBER_REGION: "IMメンバー情報をインポートする",
      PARTNER_ID:
        "Partner ID, 番号2088から始まり、16個の純粋な番号で構成される文字列",
      SELLER_ID: "Alipay支払いアカウント、携帯電話番号、または電子メール形式",
      PUBLIC_KEY: "Alipay Public Key",
      PRIVATE_KEY: "Merchant Private Key",
      WECHAT_ID: "App ID",
      WECHAT_KEY: "App Secret",
      WECHAT_PRIVATE_NUMBER: "Merchant ID",
      WECHAT_PRIVATE_KEY: "Merchant Private Key",
      IM_UPG: "IM Public Key",
      IM_UPS: "IM Private Key"
    },
    invitatecodes: {
      CREATE_INVITATECODE: "招待コードの作成",
      INVITATE_TYPE: "招待コードタイプ",
      PLEASE_CODE: "招待コードを入力してください",
      WOMAN_MEMBER: "ビューティー会員"
    },
    dialog: {
      VALID_START_AT: "開始時間",
      VALID_END_AT: "終了時間",
      TIP_PICTURE: "ポップアップ写真",
      TIP_CONDITION: "ポップアップ条件",
      TIP_SWITCH: "ポップアップスイッチ",
      IS_OPEN_TIPS: "ポップアップを有効にしますか？",
      PLEASE_TIPS_TYPE: "ポップアップの条件を選択してください"
    },
    theme: {
      THEME_ZIP: "テーマタイトル",
      THEME_OPEN: "テーマスイッチ",
      DOWMLOAD_LINK: "ダウンロードリンク",
      PLATFORM: "対象プラットフォーム",
      ALL: "全部",
      IS_OPEN_THEME: "テーマスイッチを有効にしますか",
      PLEASE_THEME_ZIP: "テーマタイトルを入力してください",
      PLEASE_PLATFORM: "対象プラットフォームを選んでください",
      THEME_FILE: "テーマファイル",
      PLEASE_THEME_FILE: "テーマファイルをアップロードしてください"
    },
    roles: {
      ROLES_LIST: "役割リスト",
      ROLES_CREATE: "役割を新規",
      ROLES_GOD_CREATE: "新規役割作成完了",
      DEIT_ROLES: "役割情報を編集",
      ROLES_NAME: "名称",
      ROLES_SHOP: "所属店舗",
      FOUND_TIME: "新規日付",
      FOUND_RENEWAL: "更新日付",
      FOUND_DETAIL: "役割情報",
      ROLES_SCOPE: "管理権限所属",
      ROLES_HINT:
        "役割の作成または編集にはリスクがありますので、ご注意してください。",
      PLEASE_ROLES_NAME: "役割名称を入力してください",
      PLEASE_ROLES_SCOPE: "所属範囲を選択",
      PLEASE_ROLES_SHOP: "所属店舗を選択",
      PLEASE_ROLES_SCOPE_PT: "所属範囲はシステムのため選択できません",
      PLEASE_PREMISSION: "役割の権限を選択してください",
      ROLE_PREMISSION: "役割権限",
      ROLE_UPDATE: "権限編集",
      ROLE_READ: "権限確認",
      ROLE_CREATE: "新規権限",
      ROLE_DELETE: "権限削除",
      CHECK_ALL: "全選択"
    },
    shoproles: {
      DEIT_ACCOUNTS: "アカウント情報を編集",
      SHOPROLE_CREATE: "店舗管理者を新規",
      SHOPROLE_NOT_CREATE: "アカウント名は特殊符号が使えません",
      PLASTROLE_CREATE: "システム管理者を新規",
      SHOPROLE_LIST: "店舗管理者一覧",
      PLATROLE_LIST: "システム管理者一覧",
      SHOPROLE_NUMBER: "管理者アカウント",
      SHOPROLE_TEL: "管理者電話",
      SHOPROLE_RECENT_TIME: "最近ログイン時間",
      SHOPROLE_RECENT_IP: "最近ログインIP",
      SHOPROLE_ROLES: "所属役割",
      PLEASE_SHOPROLE_NUMBER: "アカウント名は英数字4〜255文字を入力してください",
      PLEASE_SHOPROLE_SHOP: "所属店舗を選択してください",
      PLEASE_SHOPROLE_ROLES: "役割を選択",
      PLEASE_NAME: "店舗管理者アカウントを入力してください",
      MANAGEMENT: "管理者"
    },
    ticket: {
      TICKET_NUM: "チケット番号",
      TICKET_NAME: "チケット名",
      TICKET_TIME: "イベント期間",
      TICKET_STATUS: "チケットのステータス",
      CREATE_TIME: "システム自動記録時間",
      ENTER_TIME: "入場時間",
      GIVEN_TIME: "転送時間",
      TICKET_INFOR: "チケット情報",
      PAID_TICKET_COUNT: "支払い済みチケット",
      UNPAID_TICKET_COUNT: "未払いチケット",
      TICKET_GIVEN_LOG: "チケットサービス履歴",
      TICKET_PRICE: "チケット価格",
      TICKET_START_STATUS: "チケット開始ステータス",
      TICKET_END_STATUS: "チケット終了ステータス",
      TICKET_ID: "チケットID",
      SESSION_NAME: "セッション名",
      SEVERCE_CALLBACK: "サーバーコールバック",
      PAY_STATUS: "支払い状況",
      EXPORT_TICKET: "チケット明細をダウンロード",
      TICKET_EXPORT_MANY: "チケットの出力は１万件まで",
      TICKET_AMOUNT: "チケット数",
      TICKET_STATUS_PAY: "支払い済み",
      TICKET_STATUS_USED: "使用済み",
      TICKET_STATUS_INVALID: "無効",
      TICKET_CREATE_START: "チケット作成開始時間",
      TICKET_CREATE_END: "チケット作成終了時間",
      TICKET_MERCHANT: "商家",
      TICKET_AETTIME: "タイマー",
      TIME_DELETE_TIPS: 'チケットの時間記録を削除した場合はチケットの状態に影響しますのでご注意ください！',
      ALREADY_DELETED: '削除済',
      TICKET_INDEX_LABEL: '整理券ID',
      TICKET_CREATE_TIME:'チケット作成時間',
    },
    live: {
      LIVE_LIST: "中継一覧",
      LIVE_CREATE: "新規中継チャンネル",
      LIVE_ONE_PHOTO: "中継用画像",
      LIVE_NAME: "中継番組名",
      LIVE_TIME: "中継時間",
      LIVE_URL: "中継URL",
      LIVE_VIRTUAL: "いいね数",
      LIVE_SPUTAWAY: "有効状態",
      LIVE_STATUS: "ステータス",
      LIVE_DETAIL: "中継情報",
      LIVE_DESC: "中継説明",
      LIVE_PHOTO: "中継用ポスター",
      LIVE_LINK: "中継用URL",
      PLEASE_LIVE_LINK: "中継用URLを入力してください",
      LIVE_NO_OPEN: "開始前",
      LIVE_YJ_OPEN: "中継中",
      LIVE_RECOMMEND: "おすすめ可/不可",
      LIVE_PUTAWAY: "公開中",
      LIVE_X_DETAIL: "中継詳細",
      LIVE_SITE: "中継住所",
      LIVE_DESC_NAME: "中継名と説明を入力してください",
      PLEASE_LIVE_NAME: "中継番組名を入力してください",
      PLEASE_LIVE_DESC: "中継説明を入力してください",
      PLEASE_LIVE_NAME_LENGTH: "中継番組名は上限を超えました",
      PLEASE_LIVE_DESC_LENGTH: "中継用説明の文字数は上限を超えました",
      LIVE_DZS: "仮想いいね",
      PLEASE_LIVE_COPY: "この中継をコピーしますか？",
      LIVE_TYPE: "中継タイプ",
      LIVE_PLAT: "JP中継",
      LIVE_SHOP: "店舗中継",
      PUBLISH_START_AT: "公開時間",
      PUBLISH_END_AT: "非公開時間",
      PUBLISH_TIME: "公開状態切替時間",
      PUBLISH_START_AT_NULL: "公開時間を選んでください",
      PUBLISH_END_AT_NULL: "非公開時間を選んでください",
      STREAM_NAME: "ストリーム名",
      STREAM_NAME_NULL: "ストリーム名を入力してください",
      STREAM_LINK: "ストリームリンク",
      LIVE_VIP: "ゴールドメンバー向けLIVE配信",
      VIRTURE: "仮視聴人数",
      LIVE_LEFT_UP_COIN: "ライブ左上アイコン",
      LIVE_RIGHT_COIN: "ライブ右上アイコン",
      LIVE_LEFT_DOWN_COIN: "ライブ左下アイコン",
      LIVE_TIPS_ONE: "ライブの説明1",
      LIVE_TIPS_TWO: "ライブの説明2",
      LIVE_NOTICE: "ライブ時アナウンス",
      LIVE_NOTICE_MORE: "ライブ時アナウンスは150文字まで",
      LIVE_RESET: "チャットルームメンバーをリセット",
      LIVE_CATEGORY_NUM: "チャンネル内配信数",
      LIVE_CLASSCIFY: "配信のチャンネル",
      LIVE_RESORCE: "ライブ配信ソース",
      STREAM: "ストリーミングプッシュリンク",
      LIVE_COIN: "ライブで使ったコイン数",
      ONLINE_NUM: "視聴人数"
    },
    gift: {
      GIFT_NAME: "アイテム名",
      GIFT_ICON: "アイテムアイコン",
      GIFT_AMOUNT: "アイテムコイン",
      GIFT_ZIP: "投げ銭",
      GIFT_CREATE: "アイテムを新規",
      GIFT_DEIT: "アイテムを編集",
      GIFT_NAME_LENGTH_MAX: "アイテム名が長すぎます",
      GIFT_NAME_NULL: "アイテム名を入力してください",
      GIFT_AMOUNT_NULL: "アイテムコイン数を入力してください",
      GIFT_ICON_NULL: "アイテムアイコンをアップロードしてください",
      GIFT_ZIP_NULL: "投げ銭ファイルをアップロードしてください",
      GIFT_AMOUNT_INTEGER: "アイテムコインは整数しか入力できません",
      GIFT_BAGE: "JPギフトに付属クーポン券",
      GIFT_PUTAWAY: "公開設定",
      COIN: "コイン数",
      REWARD_TIME: "投げた時間",
      EXPORT_GIFT_REWARD: "投げ銭履歴を出力",
      GIFT_CATEGORY_NAME: "投げ銭カテゴリー名",
      GIFT_CATEGORY_IMAGE: "カテゴリー画像",
      GIFT_CATEGORY_NUM: "カテゴリー数",
      GIFT_CLASSCIFY: "ギフトのカテゴリ",
      PRESET_CREATE: "新規景品",
      PRESENT_EDIT: "景品変更"
    },
    comments: {
      COMMENTS_LIST: "コメント一覧",
      COMMENTS_CENTENT: "コメント内容",
      COMMENTS_TIME: "コメント時間"
    },
    actionslog: {
      ACTIONS_LOG_LIST: "ログ",
      ACTIONS_LOG_ADMIN: "アカンウト",
      ACTIONS_LOG_CONTENT: "内容",
      ACTIONS_LOG_TIME: "日付"
    },
    languages: {
      LANGUAGES_LIST: "言語一覧",
      LANGUAGES_CREATE: "言語を新規",
      LANGUAGE_EDIT: "言語を編集",
      LANGUAGES_NAME: "言語名",
      LANGUAGES_SIGN: "言語英語表記",
      LANGUAGES_DETAIL: "言語情報",
      PLEASE_LANGUAGES_NAME: "言語名を入力してください",
      PLEASE_LANGUAGES_SIGN: "英語表記を入力してください"
    },
    recharges: {
      RECHARGR_NUMBER: "チャージ注文番号",
      RECHARGE_SN: "チャージ取引番号",
      RECHARGE_PRICE: "チャージ金額",
      RECHARGE_COIN: "チャージで付与コイン数",
      RECHARGE_POINT: "チャージで付与ポイント数",
      RECHARGE_TIME: "チャージ時間",
      RECHARGES_LIST: "チャージ一覧",
      RECHARGE_PRICE: "金額",
      EXCHANGE_COIN: "チャージコイン数",
      EXCHANGE_POINT: "付与ポイント数",
      BUY_IN_GOODS: "アプリ内購入商品ID",
      RECHARGE_IS_VALID: "チャージを有効にしますか",
      CREATE_RECHARGE: "チャージを作成",
      EDIT_RECHARGE: "チャージを編集",
      PLEASE_RECHARGE_PRECE: "チャージ額を入力してください",
      PLEASE_RECHARGE_COIN: "チャージコイン数を入力してください",
      PLEASE_RECHARGE_POINT: "付与ポイント数を入力してください",
      PLEASE_IPAID: "アプリ内購入商品IDを入力してください",
      PLEASE_VALID: "有効にしますか",
      RECHARGE_AMOUNT_INTPRICE: "金額は整数しか入力できません",
      RECHARGE_AMOUNT_INTCOIN: "チャージコイン数は整数しか入力できません",
      RECHARGE_AMOUNT_INTPOINT: "付与ポイント数は整数しか入力できません",
      EXPORT_COIN_RECHARGE: "コインのチャージ履歴を出力",
      COIN_EXPORT_MANY: "出力するコインのチャージ履歴は1万件まで"
    },
    musics: {
      MUSIOCS_LIST: "音楽ジャンルリスト",
      MUSIOCS_TYPE: "音楽ジャンル",
      MUSIOCS_LOGO: "音楽ロゴ",
      MUSIOCS_ACTIVITY: "イベント数",
      MUSIOCS_DATEIL: "音楽ジャンル情報",
      PLEASE_MUSIOCS_TYPR: "音楽ジャンルは入力必須です",
      PLEASE_LOGO: "音楽ロゴをアップロードしてください",
      PLEASE_MUSIOCS_TYPR_LENGTH: "文字数が上限を超えています",
      CREATE_MUSIC: "音楽をしんき",
      EDIT_MUSIC: "音楽を編集"
    },
    membership: {
      MEMBERSHIP_LEVEL_NAME: "会員レベル名",
      CREATE_MEMBERSHIP: "ゴールドメンバーを新規",
      PLEASE_MEMBERS_GRADE_NAME: "会員種類を選択",
      NONE_VIP_MEMBERSHIP: "無料会員"
    },
    banner: {
      BANER_LIST: "広告一覧",
      BANER_TITLE: "タイトル",
      BANER_DATEIL: "広告情報",
      BANER_FOUND_ONE: "バナーを作成",
      BANER_FOUND_TWO: "店舗広告を作成",
      REGIONS_BANER_TITLE: "タイトルは必要です",
      BANER_PHOTO: "画像をアップロードしてください",
      BANER_SORT: "並び順は整数です",
      BANER_HINT: "画像のサイズは960*540まで",
      BANER_HINT_TWO: "画像は１MBまで",
      CLICKS_NUMBER: "クリック数",
      CLICKS_EMPTY: "クリア",
      BANNER_NOTICE_ONE:
        "広告バナー用横型1画像のサイズは960×540以上、16:9レートは必要です。",
      BANNER_NOTICE_TWO:
        "広告バナー用横型2画像のサイズは960×540以上、16:9レートは必要です。",
      SURE_CLEAR: "クリアしますか？"
    },
    splashes: {
      SPLASHES: "スプラッシュ",
      SPLASHES_LIST: "スプラッシュ一覧",
      SPLASHES_CREATE: "スプラッシュを作成",
      SPLASHES_TIME_SC: "時間長",
      SPLASHES_TOP_TIME: "公開時間",
      SPLASHES_UP_TIME: "非公開時間",
      SPLASHES_SHOW_TIME: "展示時間",
      ANDRIOD_PHOTO: "Andriod画像",
      IOS_PHOTO: "iOS画像",
      SPLASHES_TOP_TIME_xj: "公開時間新しい順",
      SPLASHES_TOP_TIME_jx: "公開時間古い順",
      SPLASHES_UP_TIME_xj: "非公開時間新しい順",
      SPLASHES_UP_TIME_jx: "非公開時間古い順",
      SPLASHES_HINT: "画像のサイズ（ピクセル）を確かめてください",
      SPLASHES_HINT_TWO: "展示時間を確かめてください",
      PLEASE_ANDRIOD_PHOTO: "Android画像を選択してください",
      PLEASE_IOS_PHOTO: "iOS画像を選択してください",
      PLEASE_SHOW_TIME: "展示時間は整数のみです",
      PLEASE_SPLASHES_SHOW_TIME: "展示時間を入力してください",
      PLEASE_SPLASHES_LINK: "正しいウェブサイトを入力してください",
      SPLASHES_DETAIL: "スプラッシュ情報",
      SPLASHES_PHOTO_BL: "画像のサイズ（ピクセル）を確かめてください",
      SPLASHES_PHOTO_TIME: "展示時間を確かめてください",
      DELETE_SPLASHES: "削除するスプラッシュ画像を選択してください"
    },
    versions: {
      VERSIONS_LIST: "バージョン一覧",
      CREATE_VERSIONS: "バージョンを作成",
      VERSIONS_NUMVER: "バージョン番号",
      VERSIONS_CENTEN: "更新内容",
      VERSIONS_URL: "ダウンロード先URL",
      VERSIONS_DETAIL: "バージョン情報",
      VERSIONS_WB_URL: "外部リンク",
      VERSIONS_DESC: "説明",
      SPLASHES_VERSIONS_DESC: "説明を入力してください",
      VERSIONS_DESC_ONE: "バージョン番号のフォーマットを確かめてください",
      VERSIONS_DESC_TWO: "ダウンロード先を確かめてください",
      VERSIONS_DESC_THREE:
        "作成後デフォルトは無効となり、手動で有効にしてください",
      VERSION_CREATE_NEW: "作成时间新しい順",
      VERSION_CREATE_OLD: "作成時間古い順",
      DELETE_VERSIONS: "削除するバージョンを選択してください",
      PLEASE_CLOSE_AN: "有効になったAndroidバージョンを閉じてください",
      PLEASE_CLOSE_IOS: "有効になったiOSバージョンを閉じてください",
      EDIT_VERSION: "バージョンを編集"
    },
    pushes: {
      PUSHES: "プッシュ通知",
      PUSHES_LIST: "プッシュ通知一覧",
      PUSHES_CREATE: "プッシュ通知を作成",
      PUSHES_TIME: "送信時間",
      PUSHES_DETAIL: "送信情報",
      PUSHES_TIMING: "タイマー",
      PUSHES_CREATE_TIME: "新規時間",
      PUSHES_SELECT_TYPE: "タイプを選択してください",
      PUSHES_IMMED_TYPE: "即時送信",
      PUSHES_TIMING_TYPE: "定時送信",
      ALL_PLATFORM: "プラットフォーム全体",
      Yj_PLATFORM: "送信済み",
      WL_PLATFORM: "未送信",
      PUSHES_TITLE: "タイトルは最大文字数制限を超えました",
      PUSHES_TYPE: "送信タイプを選択してください",
      LINK_SHOP: "近い店舗",
      LINK_REC_SHOP: "おすすめ店舗",
      LINK_ACTIVITY: "本日イベント",
      LINK_CUSTOM: "カスタマイズ",
      LINK_PUSHES_TITLE: "タイトルを入力してください",
      PUSH_TIME_NEW_OLD: "送信時間新しい順",
      PUSH_TIME_OLD_NEW: "送信時間古い順",
      PUSH_AGAIN: "再送",
      PERSON_INFORMATION: "プロフィール",
      MY_POINT: "ポイント数",
      MY_ORDER: "注文履歴",
      REGISTER_PAGE: "登録ページ",
      FRIENDS_APPLY: "友達リクエスト",
      MY_INVITE: "自分の招待",
      FEEDBACK: "フィードバック",
      MY_COUPONS: "割引クーポン"
    },
    prize: {
      PRIZE_SET: "当たり設定设置",
      PRIZE_LIST: "当たりリスト",
      PRIZE_NAME: "当たり名前",
      PRIZE_CREATE: "当たり条件を作る",
      PRIZE_PHOTO: "当たり画像",
      PRIZE_PROBABILITY: "当たり確率",
      PRIZE_PPINT: "贈るポイント",
      PRIZE_EDIT: "当たり条件の情報を編集する",
      PRIZE_DETAIL: "当たり情報",
      PRIZE_NAME_LENGTH: "当たり名は制限を超える",
      PLEASE_PRIZE_NAME: "当たり名前を入力してください",
      PLEASE_PRIZE_PHOTO: "当たり画像をアプロードしてください",
      PLEASE_PRIZE_PROBABILITY: "当たり確率を入力してください",
      PRIZE_PROBABILITY_RANGE: "当たり確率は0と1の間",
      PRIZE_PROBABILITY_NUMBER: "当たり確率数字のみを入力入力してください",
      PRIZE_PROBABILITY_DECI: "当たり確率が小数点以下4桁まで入力できる",
      PRIZE_PPINT_NUMBER: "贈るポイントは整数のみ",
      PLEASE_PRIZE_PPINT: "贈るポイントを入力してください",
      PLEASE_PRIZE_PESULT: "結果",
      PRIZE_TIME: "ゲームタイム",
      PRIZE_DETAILS: "ゲームの消費明细",
      PRIZE_DETAILS_LIST: "ゲームの明細表",
      PRIZE_DETAILS_GOLD: "使ったコイン数",
      PRIZE_PESOLVING: "解像度を320*320 以下をベースにしてください",
      USER_JID: "ユーザーJ_ID",
      PRIZE: "勝利",
      UNPRIZE: "勝てない"
    },
    regions: {
      SHOPS_NUM: "店舗数",
      CREATE_REGIONS: "新規エリア",
      PLEASE_REGIONS_NAME: "エリア名を入力",
      REGIONS_NAME: "エリア名",
      REGIONS_DETAIL: "エリア情報",
      ADD_SUBREGION: "下位区域を追加",
      REGION: '地域',
    },
    points: {
      INCREASE_POINTS: "獲得ポイント",
      CONSUMPTION_POINTS: "利用ポイント",
      CONSUMER_STORES: "利用店舗",
      CONSUMER_ACTIVITIES: "利用イベント",
      SOURCE: "状態",
      COUPON_PURCHASE: "クーポンを購入",
      STORE_SIGNIN: "店舗チェックイン",
      EVOWECHATPAY: "WeChatPay",
      CREDITCARD: "クレジットカード",
      INCREASE_TOTAL: "ポイント合計",
      REDUCE_TOTAL: "支払いポイント",
      EXPORT_SIGNIN_RECORD: "ダウンロード",
      DOWN_LOAD: "ダウンロード",
      EXPORT_LOADING: "ダウンロード中...ダウンロードリストを確認",
      POINT_VALID_DAY: "ポイントの有効期限",
      POINT_EXPORT_MANY: "ポイントの出力は１万件まで",
      SUBSCRIPTION_GIFT: "購読ギフト"
    }
  },
  router: {
    common: {
      CREATE: '追加',
      EDIT: '編集',
      ACTIVITY_SESSION: 'イベント回',
      ACTIVITY_TICKET: 'チケット',
      INDEX: 'インデックス',
      ORDER: 'イベント注文',
      ORDER_SAT: '注文統計',
      QR_CODE: '二次元コード管理',
      TICKET: 'チケット管理',
      USERGOODS_MANAGEMENT: 'ユーザー商品管理'
    }
  }
};
